import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
    selector: 'gh-trial-us-component',
    templateUrl: 'trial-us.component.html',
    styleUrls: ['trial-us.component.scss'],
    standalone: false
})

export class TrialUsComponent {
  cdnPath = environment.cdnPath;
}
